import { IFavoriteLine } from "@/domain/entities/favoriteLine";
import { IResultData } from "@/domain/entities/shared/result";
import { useLineStore } from "@/stores/lineStore";
import {
  PROVIDE_KEY_REMOVE_LOADING_IMAGE,
  PROVIDE_KEY_SHOW_LOADING_IMAGE,
  RemoveLoadingImage,
  ShowLoadingImage,
} from "@/types";
import { inject, ref } from "vue";

interface IRemoveFavoriteLineParams {
  onSuccess?: (result: IResultData<boolean>, lineId: string) => void;
  onError?: (result: IResultData<boolean>) => void;
}

export const useRemoveFavoriteLine = ({
  onSuccess,
  onError,
}: IRemoveFavoriteLineParams) => {
  const showLoadingImage = inject(
    PROVIDE_KEY_SHOW_LOADING_IMAGE
  ) as ShowLoadingImage;
  const removeLoadingImage = inject(
    PROVIDE_KEY_REMOVE_LOADING_IMAGE
  ) as RemoveLoadingImage;

  const lineStore = useLineStore();
  const favoriteLineToRemove = ref<IFavoriteLine>();

  const removeFavoriteLine = async (line: IFavoriteLine) => {
    showLoadingImage();

    const removeResult = await lineStore.removeFavoriteLine(
      line.turnId ?? "",
      line.getOnBusStop?.id,
      line.getOffBusStop?.id
    );

    removeLoadingImage();

    removeResult.isSuccess
      ? onSuccess && onSuccess(removeResult, line.lineId)
      : onError && onError(removeResult);
  };

  const updateFavoriteLineToRemove = (line: IFavoriteLine) => {
    favoriteLineToRemove.value = line;
  };

  return {
    favoriteLineToRemove,
    removeFavoriteLine,
    updateFavoriteLineToRemove,
  };
};
